import { createQueryKeyFactory } from '@/utils/queries'

const familyQueryKeys = createQueryKeyFactory(['families'])

export default {
    ...familyQueryKeys
}
